import React from "react";

/* One icon, and only when there is something for it to do.
 *
 * This was a title bar reading "RFP Copilot", then a labelled "Show chats" bar.
 * Both were the same mistake at different sizes: a full-width strip with a rule
 * under it, framing a single control. The rule in particular drew a boundary
 * across the top of every conversation to hold one button.
 *
 * What is left is the button. No bar, no border, no background, no label — the
 * icon shows a panel opening from the left, which is the whole message. It
 * still occupies its own row rather than floating over the transcript, because
 * an absolutely positioned control at the top-left would land on the first
 * turn's avatar at exactly the width this route is usually read at.
 */

const CopilotHeader = ({ showChatsButton = false, onShowChats }) => {
  if (!showChatsButton) return null;

  return (
    <div className="flex shrink-0 items-center px-3 pt-3">
      <button
        type="button"
        onClick={onShowChats}
        aria-label="Show chats"
        title="Show chats"
        className="flex h-9 w-9 items-center justify-center rounded-[10px] text-[#6B6472] transition-colors duration-200 hover:bg-[#18101C]/[0.06] hover:text-[#18101C] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A04A97] motion-reduce:transition-none"
      >
        <svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          {/* Mirror of the rail's own collapse icon: a panel opening left. */}
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M9 4v16" />
          <path d="M13 10l2 2-2 2" />
        </svg>
      </button>
    </div>
  );
};

export default CopilotHeader;
